enum BotSubmitAction {
    BrokerConnectionFlightHelp = 'BrokerConnectionFlightHelp',
    BrokerConnectionFlightPassengers = 'BrokerConnectionFlightPassengers',
    BrokerConnectionSendMessageToFlightTeam = 'BrokerConnectionSendMessageToFlightTeam',
    BrokerConnectionSendPassengersMessageToFlightTeam = 'BrokerConnectionSendPassengersMessageToFlightTeam',
    BroadcastMessaging = 'BroadcastMessaging',
    MisconnectedCustomers = 'MisconnectedCustomers',
    ResolveConversation = 'ResolveConversation',
    RateConversation = 'RateConversation',
    NewConversation = 'NewConversation'
}

export default BotSubmitAction;
